import React, { Component, Fragment } from "react";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const DEFAULT_DAYS = Array.apply(null, { length: 7 })
  .map(Number.call, Number)
  .map(n => (n + 1) % 7);
const DAYS_LABELS = [
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
  "Dimanche"
];

export default class ProductDays extends Component {
  state = {};

  daysChanged = day => e => {
    const { days } = this.props;
    const _days = days || DEFAULT_DAYS;
    const __days = e.target.checked
      ? [..._days, day]
      : _days.filter(d => d !== day);
    this.props.changeDays("days", __days, "string");
  };

  render() {
    const { days } = this.props;
    const _days = days || DEFAULT_DAYS;
    return (
      <Fragment>
        <Typography variant="body2">Jours de disponibilité</Typography>
        <Grid container spacing={16}>
          {DEFAULT_DAYS.map(d => {
            return (
              <Grid item xs={12} sm={4} key={d}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={_days.includes(d)}
                      onChange={this.daysChanged(d)}
                      value="day"
                      color="secondary"
                    />
                  }
                  label={DAYS_LABELS[(d + 6) % 7]}
                />
              </Grid>
            );
          })}
        </Grid>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/products/ProductDays.js